// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"39":"3928508c","437":"29711507","523":"a21db167","529":"fe94f6c3","636":"67bae46e","922":"a6f3346e","980":"f9315ff4"}[chunkId] + ".js";
};